import React from "react"
import { Flex, Spinner } from "@chakra-ui/react"

export const Loading = ({ loading }: { loading: boolean }): JSX.Element => (
  <>
    {loading && (
      <Flex align={"center"} justify="center">
        <Spinner />
      </Flex>
    )}
  </>
)
